export default __webpack_public_path__ + "static/media/logo-verticalx1080.d008d31f.png";